import {
    BrandVariants,
    createDarkTheme,
    createHighContrastTheme,
    createLightTheme,
    Theme,
    webLightTheme,
    webDarkTheme,
} from '@fluentui/react-components';
import { OwaPalette } from 'owa-theme-shared';
import { getIsMsHighContrast } from 'owa-high-contrast';
import { getIsDarkBaseTheme } from 'owa-theme';
import { getIsDarkTheme } from 'owa-fabric-theme';

export function createFluentTheme(theme: OwaPalette): Theme {
    const brandVariants = getBrandVariants(theme);
    if (getIsMsHighContrast()) {
        return createHighContrastTheme();
    } else if (getIsDarkBaseTheme() || getIsDarkTheme()) {
        return brandVariants ? createDarkTheme(brandVariants) : webDarkTheme;
    } else {
        return brandVariants ? createLightTheme(brandVariants) : webLightTheme;
    }
}

function getBrandVariants(theme: OwaPalette): BrandVariants | undefined {
    if (
        !theme.themeDarker ||
        !theme.themeDark ||
        !theme.themeDarkAlt ||
        !theme.themePrimary ||
        !theme.themeSecondary ||
        !theme.themeTertiary ||
        !theme.themeLight ||
        !theme.themeLighter
    ) {
        return undefined;
    }
    return {
        shade60: theme.themeDarker,
        shade50: theme.themeDark,
        shade40: theme.themeDarker,
        shade30: theme.themeDarkAlt,
        shade20: theme.themeDark,
        shade10: theme.themeDarkAlt,
        primary: theme.themePrimary,
        tint10: theme.themePrimary,
        tint20: theme.themeSecondary,
        tint30: theme.themeTertiary,
        tint40: theme.themeTertiary,
        tint50: theme.themeLight,
        tint60: theme.themeLighter,
    };
}
